import { ToggleButton } from "@root/clientFrontend/features/scout/components/WorkSelector/uiParts/ToggleButton";
import { Label } from "@root/shared/components/Label";
import { type LayoutProps } from "@root/clientFrontend/features/scout/components/WorkSelector/type";
import * as styles from "./styles.css";

export const SpLayout = ({
  isRequired,
  toggleButtonText,
  onToggleButtonClick,
  selectableWorksCount,
  totalWorksCount,
  children,
  toggleButtonClassName,
  isDescriptionVisible,
  recommendText,
}: LayoutProps) => (
  <>
    <div className={styles.titleAndButtonOuter} id="js-work-selector">
      <p className={styles.title}>
        求人{!isRequired && <>を選択</>}
        {isRequired ? (
          <Label theme="red" className={styles.label}>
            必須
          </Label>
        ) : (
          <Label theme="lightGray" className={styles.label}>
            任意
          </Label>
        )}
      </p>
      <ToggleButton
        text={toggleButtonText}
        onClick={onToggleButtonClick}
        className={toggleButtonClassName}
      />
    </div>
    {children}
    <p className={styles.countOuter} aria-label="求人数">
      <span className={styles.currentCount}>{selectableWorksCount}</span>/{totalWorksCount}件表示中
    </p>
    {recommendText && <p className={styles.recommendText}>{recommendText}</p>}
    {isDescriptionVisible && (
      <p className={styles.description}>
        選択した求人で、スカウトを送信できる求職者のみが検索結果に表示されます。
      </p>
    )}
  </>
);
